import { HostBinding, Component, OnInit, OnDestroy } from '@angular/core';

import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { VestibularService } from '../shared/vestibular.service';
import { Vestibular } from 'models/vestibular';
import { environment } from '../../../environments/environment';
import { ModalService } from 'app/shared/modal/modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ceuma',
  templateUrl: './ceuma.component.html',
  styleUrls: ['./ceuma.component.scss'],
  animations: [routerTransition],
})
export class VestibularCeumaComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';
  environment = environment;
  vestibulares: Vestibular[] = null;
  vestibularesCarregando = true;
  cursosVigentes:any[];
  cursoSelecionado:any;
  turnoSelecionado:any;
  modalidadeSelecionada:String;
  opcoesValoresCurso:any[];
  formasIngresso:any[];
  confCapitalize = {
    forcar: ['ceuma'],
    forcarCaixaAlta: ['ead', '(ead)'],
  };
  urlVestibular:string = '';

  constructor(
    private vestibularService: VestibularService,
    private modalService: ModalService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.limparDadosMarketPlace();
    this.getVestibulares()
  }

  getVestibulares() {
    this.vestibularService.vestibularesVigentes().then((vestibulares: Vestibular[]) => {
      console.log(vestibulares)

      this.insertPropGtag(vestibulares)
      this.vestibulares = vestibulares;
      this.changeVestibuarName();
      this.vestibularesCarregando = false;
    });
  }

  insertPropGtag(vestibulares: Vestibular[]) {
    vestibulares.map((vestibular: Vestibular) => {
      let iniciaisVestibular = vestibular.titulo.slice(0, 2).toLocaleLowerCase() + '-'
      let restoDaFrase = vestibular.titulo.toLocaleLowerCase().split(' ').slice(1)
      let gtagNameVestibular = vestibular.codigo + '-' + vestibular.anoSemestre + '-' + iniciaisVestibular + restoDaFrase
      let namesTag = gtagNameVestibular.split(',').join('-')

      let nameTagCut = namesTag.slice(0, 25)

      vestibular.gtagName = nameTagCut
    })
  }

  changeVestibuarName(){
    this.vestibulares.forEach(v =>{
      v.titulo = v.titulo[0].toLocaleUpperCase() + v.titulo.substr(1).toLowerCase();
      v.titulo = v.titulo.replace("são luís", "São Luís");
      v.titulo = v.titulo.replace("imperatriz", "Imperatriz");
      v.titulo = v.titulo.replace("prouni", "Prouni");
      v.titulo = v.titulo.replace("renascença", "Renascença");
      v.titulo = v.titulo.replace("anil", "Anil");
    });
  }

  openModalOpcaoCurso(cursoVigente) {
    this.formasIngresso = [];
    this.opcoesValoresCurso = [];
    this.urlVestibular = '';
    this.cursoSelecionado = [];
    this.modalidadeSelecionada = '';
    this.cursoSelecionado = cursoVigente;
    this.modalService.open('opcaoCurso');
  }

  onChangeModalidadeSelecionada(){
    this.formasIngresso = [];
    this.urlVestibular = '';
    //console.log(this.modalidadeSelecionada);
    this.opcoesValoresCurso = [];
    let valores = [];
    this.cursoSelecionado.opcoesCursoVestibular.filter(el=>{
      let isInserido=false;
      valores.forEach((valor)=>{
        if(valor.valor==el.valor_Curso_Desconto){
          isInserido=true;
        }
      });
      if(!isInserido && this.modalidadeSelecionada==el.modalidade){
        //Adiciona os valores que são diferentes do que existe no array
        valores.push({valor:el.valor_Curso_Desconto,descricao:el.descricao});
        return true;
      }else{
        return false;
      }
    });
    //console.log(valores);
    let opcoesValoresCurso = [];
    let campus = [];
    let opcoes = [];
    let opcoesCampus=[];
    let opcoesCampusTurno=[];
    // Para cada valor adicionado, vamos fazer um foreach para adicionar as opções desses valores
    valores.forEach((valor)=>{
      this.cursoSelecionado.opcoesCursoVestibular.forEach((opcaoCursoVestibular)=>{
        if(opcaoCursoVestibular.modalidade==this.modalidadeSelecionada){
          // Caso a modalidade tenha sido encontrada, precisamos buscar os valores e colocá-los em array de acordo com os valores de cada
          if(valor.valor==opcaoCursoVestibular.valor_Curso_Desconto){
            opcoes.push(opcaoCursoVestibular);
          }
        }
      });
      //console.log(opcoes);
      // agora que temos as opções, precisamos pegá-las e separá-las por campus
      opcoes.filter(el=>{
        if(campus.indexOf(el.campus)===-1){
          //Adiciona
          //console.log(el);
          campus.push(el.campus);
          return true;
        }else{
          return false;
        }
      });
      campus.forEach((c)=>{
        opcoes.forEach((o)=>{
          //console.log(valor+"   "+o.valor_Curso_Desconto);
          //console.log(c);
          //console.log(o);
          if(c==o.campus && valor.valor==o.valor_Curso_Desconto){
            opcoesCampus.push(o);
          }
        });
        //console.log(opcoesCampus);
        opcoesCampusTurno.push({campus:c,opcoesCampus:opcoesCampus});
        opcoesCampus = [];
      });
      //console.log(opcoesCampusTurno);
      opcoesValoresCurso.push({valor:valor.valor,descricao:valor.descricao,opcoes:opcoesCampusTurno});
      opcoesCampusTurno = [];
    });
    this.opcoesValoresCurso = opcoesValoresCurso;
    opcoesValoresCurso = [];
    //console.log(this.opcoesValoresCurso);
  }

  onClickOpcaoCampus(opcao){
    this.formasIngresso = [];
    this.turnoSelecionado = opcao;
    // Buscando formas de ingresso
    //console.log(this.turnoSelecionado);
    this.vestibularService.formasDeIngresso(this.turnoSelecionado.codigo, this.turnoSelecionado.turno).then((formasDeIngresso)=>{
      this.formasIngresso = formasDeIngresso;
    });
  }

  acessarInscricao(){
    window.location.href = this.urlVestibular;
  }

  getSrcImgVestibular(titulo, isEad) {
    const tituloVestibular = titulo.toLocaleLowerCase()

    if (tituloVestibular.includes('medicina: reingresso (são luis)')) {
      return '/assets/images/vestibular/medicina-reingresso-sao-luis.jpg';

    } else if (tituloVestibular.includes('medicina: use a nota do enem (são luís)')) {
      return '/assets/images/vestibular/medicina-transferencia-externa.jpg';

    } else if (tituloVestibular.includes('processo seletivo medicina presencial unieuro')) {
      return '/assets/images/vestibular/medicina-vestibular.jpg';

    } else if (tituloVestibular.includes('processo seletivo medicina nota enem unieuro')) {
      return '/assets/images/vestibular/medicina-transferencia-externa.jpg';

    } else if (tituloVestibular.includes('vestibular medicina nota enem')) {
      return '/assets/images/vestibular/medicina-transferencia-externa.jpg';

    } else if (tituloVestibular.includes('redação digital - asa sul')) {
      return '/assets/images/vestibular/imagem-vestibular-2.jpg';

    } else if (tituloVestibular.includes('nota enem - asa sul')) {
      return '/assets/images/vestibular/imagem-vestibular-1.jpg';

    } else if (tituloVestibular.includes('redação digital - águas claras')) {
      return '/assets/images/vestibular/imagem-vestibular-3.jpg';

    } else if (tituloVestibular.includes('nota enem - águas claras')) {
      return '/assets/images/vestibular/imagem-vestibular-4.jpg';

    } else if (tituloVestibular.includes('cursos ead - vestibular digital unieuro')) {
      return '/assets/images/vestibular/imagem-vestibular-2.jpg';

    } else if (tituloVestibular.includes('cursos ead - enem unieuro')) {
      return '/assets/images/vestibular/imagem-vestibular-1.jpg';

    } else if (tituloVestibular.includes('vaga de graduado - asa sul')) {
      return '/assets/images/vestibular/imagem-vestibular-3.jpg';

    } else if (tituloVestibular.includes('vaga de graduado - águas claras')) {
      return '/assets/images/vestibular/imagem-vestibular-4.jpg';

    } else if (tituloVestibular.includes('transferência externa - águas claras')) {
      return '/assets/images/vestibular/imagem-vestibular-2.jpg';

    } else if (tituloVestibular.includes('transferência externa - asa sul')) {
      return '/assets/images/vestibular/imagem-vestibular-1.jpg';

    } else if (tituloVestibular.includes('reingresso - águas claras')) {
      return '/assets/images/vestibular/imagem-vestibular-3.jpg';

    } else if (tituloVestibular.includes('reingresso - asa sul')) {
      return '/assets/images/vestibular/imagem-vestibular-4.jpg';

    } else if (tituloVestibular.includes('processo seletivo - medicina reingresso unifamaz')) {
      return '/assets/images/vestibular/medicina-reingresso-imperatriz.jpg';

    } else if (tituloVestibular.includes('medicina: reingresso')) {
      return '/assets/images/vestibular/medicina-reingresso-imperatriz.jpg';

    } else if (tituloVestibular.includes('medicina: transferência externa (imperatriz)')) {
      return '/assets/images/vestibular/medicina-transferencia-externa-imperatriz.jpg';

    } else if (tituloVestibular.includes('processo seletivo - medicina transferência externa')) {
      return '/assets/images/vestibular/medicina-transferencia-externa.jpg';

    } else if (tituloVestibular.includes('processo seletivo - medicina reingresso unifamaz')) {
      return '/assets/images/vestibular/reingresso.jpg';

    } else if (tituloVestibular.includes('processo seletivo - prouni - unifamaz')) {
      return '/assets/images/vestibular/prouni.jpg';

    } else if (tituloVestibular.includes('prouni cursos presenciais (imperatriz)')) {
      return '/assets/images/vestibular/prouni-cursos-presenciais-imperatriz.jpg';

    } else if (tituloVestibular.includes('prouni cursos presenciais (renascença)')) {
      return '/assets/images/vestibular/prouni-cursos-presenciais-renascenca.jpg';

    } else if (tituloVestibular.includes('prouni cursos presenciais (turu)')) {
      return '/assets/images/vestibular/prouni-cursos-presenciais-turu.jpg';

    } else if (tituloVestibular.includes('concurso de bolsas')) {
      return '/assets/images/vestibular/concurso-de-bolsas.jpg';

    } else if (tituloVestibular.includes('processo seletivo fies')) {
      return '/assets/images/vestibular/agendado.jpg';

    } else if (!isEad && tituloVestibular.includes('use a nota enem')) {
      return '/assets/images/vestibular/nota-enem.jpg';

    } else if (!isEad && tituloVestibular.includes('use a nota do enem')) {
      return '/assets/images/vestibular/nota-enem.jpg';

    } else if (isEad && tituloVestibular.includes('use a nota do enem')) {
      return '/assets/images/vestibular/nota-do-enem-ead.jpg';

    } else if(tituloVestibular.includes('reingresso')) {
      return '/assets/images/vestibular/reingresso.jpg';

    } else if(tituloVestibular.includes('externa')) {
      return '/assets/images/vestibular/transferencia-externa.jpg';

    } else if(tituloVestibular.includes('vaga de graduado')) {
      return '/assets/images/vestibular/vaga-de-graduado.jpg';

    } else if(tituloVestibular.includes('vestibular digital/nota enem cursos presenciais')) {
      return '/assets/images/vestibular/vestibular-digital-nota-enem-cursos-presenciais.jpg';

    } else if(tituloVestibular.includes('vestibular digital/nota enem cursos ead')) {
      return '/assets/images/vestibular/vestibular-digital-nota-enem-cursos-ead.jpg';

    } else if(tituloVestibular.includes('processo seletivo digital ead ceuma')) {
      return '/assets/images/vestibular/imagem-vestibular-1.jpg';

    } else if(tituloVestibular.includes('processo seletivo enem ead ceuma')) {
      return '/assets/images/vestibular/imagem-vestibular-2.jpg';

    } else if(tituloVestibular.includes('transferencia externa e vaga de graduado')) {
      return '/assets/images/vestibular/transferencia-externa.jpg';

    } else if(tituloVestibular.includes('vaga graduado')) {
      return '/assets/images/vestibular/vaga-de-graduado.jpg';

    } else if(tituloVestibular.includes('medicina: vestibular')) {
      return '/assets/images/vestibular/medicina-vestibular.jpg';

    } else if(tituloVestibular.includes('direito - redação digital')) {
      return '/assets/images/vestibular/direito-redação-digital.jpg';

    } else if(tituloVestibular.includes('direito - nota enem')) {
      return '/assets/images/vestibular/direito-nota-enem.jpg';

    } else if(tituloVestibular.includes('vestibular on line/ vaga enem')) {
      return '/assets/images/vestibular/vestibular-online-vaga-do-enem.jpg';

    } else if(tituloVestibular.includes('transf. externa e vaga de graduados')) {
      return '/assets/images/vestibular/transferencia-externa.jpg';

    } else if(tituloVestibular.includes('vestibular ead - use a nota do enem')) {
      return '/assets/images/vestibular/processo-seletivo-enem-ead.jpg';

    } else if(tituloVestibular.includes('vestibular ead')) {
      return '/assets/images/vestibular/vestibular-digital-ead.jpg';

    } else if(tituloVestibular.includes('prouni - cursos (ead)')) {
      return '/assets/images/vestibular/prouni-cursos-(ead).jpg';

    } else if(tituloVestibular.includes('fies cursos presenciais (renascença)')) {
      return '/assets/images/vestibular/fies-cursos-presenciais-(renascenca).jpg';

    } else if(tituloVestibular.includes('fies cursos presenciais (turu)')) {
      return '/assets/images/vestibular/fies-cursos-presenciais-(turu).jpg';

    } else if(tituloVestibular.includes('fies cursos presenciais (imperatriz)')) {
      return '/assets/images/vestibular/fies-cursos-presenciais-(imperatriz).jpg';

    } else if(!isEad && tituloVestibular.includes('vestibular digital')) {
        return '/assets/images/vestibular/vestibular-digital-presencial.jpg';

    } else if (isEad && tituloVestibular.includes('vestibular digital')) {
        return '/assets/images/vestibular/vestibular-digital-ead.jpg';

    } else {
      return '/assets/images/vestibular/tradicional.jpg';
    }

  }

  isInscricaoAberta(vestibular) {
    return this.vestibularService.isInscricaoAberta(vestibular);
  }

  redirectClickVestibular(sigla: string, vestibular: Vestibular) {
    console.log(vestibular)
    if (sigla === 'LE') {
      window.location.href = vestibular.linkExterno
    } else {
      const result = this.isInscricaoAberta(vestibular)

      result === 1 ? this.router.navigate(['/vestibular/inscricao', vestibular.id.ano, vestibular.id.codigo]) : this.router.navigate(['/vestibular/resultados'])
    }
  }

  returnClassColorTagVestibular(vestibular: Vestibular) {
    const vestibularAberto = this.isInscricaoAberta(vestibular)
    let className: string;

    if (vestibularAberto) {
      if (vestibular.isEad) {
        className = 'ead'

        return className
      }

      if (vestibular.titulo.toLowerCase().includes('medicina')) {
        className = 'medicina'

        return className
      }

      className = 'ativo'
      return className
    } else {
      className = 'encerrado'

      return className
    }
  }

  isPrensencialEAD(tituloVestibular: string): boolean {
    const titulo = tituloVestibular.toLocaleLowerCase()

    if (['transferência externa', 'transf. externa e vaga de graduados', 'reingresso', 'vaga de graduado', 'vaga graduado'].includes(titulo)) {
      return true
    }

    return false
  }

  limparDadosMarketPlace(){
    if(sessionStorage.getItem("marketPlaceData") != null){
      sessionStorage.setItem("byMarketPlace", "true");
      sessionStorage.setItem("marketPlaceData", null);
    }
  }
}
